/**
 *
 * @component 个人中心/我的方案--装修方案/我的方案tab
 *
 **/

import './MySchemeTab.scss';
import HouseTypeCard from '@/components/HouseTypeCardDecoration';
// import { Spin } from 'antd';
import { useRouterTarget } from '&/utils/customHooks';
import { useEffect, useState } from 'react';
import { isMobile } from '&/utils/common';
import Hammer from 'hammerjs';
import { Spin, Modal, message, Button } from 'antd';
import {
    getProjectList,
    schemeDiscard,
    deleteScheme,
    schemeReply,
} from '@/api/personCenter/decorationManage';
import './MySchemeTabMobile.scss';
import dayjs from 'dayjs';
import { bodyScrollToBottom } from '&/utils/common';
import useDidUpdate from '&/utils/customHooks/useDidUpdate';
import { ExclamationCircleOutlined, DeleteOutlined } from '@ant-design/icons';
export default function MySchemeTab(props) {
    const targetPage = useRouterTarget();
    const touchEl = useRef(null);
    const targetDetail = projectId => {
        targetPage({
            pathname: '/user-center/decoration-scheme/decoration-design',
            search: {
                projectId,
            },
        });
    };

    const [projectList, setProjectList] = useState([]);
    const [page, setPage] = useState({ page: 1, pageNum: 8 });
    const [totalList, setTotalList] = useState(0);
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [freshLoading, setFreshLoading] = useState(false);
    const [loadMoreLoading, setLoadMoreLoading] = useState(false);

    const fetchData = (setLoading, isFresh = false, currentPage) => {
        const { type } = props;
        const api = {
            discard: schemeDiscard,
            active: getProjectList,
        };
        api[type]({
            page: currentPage,
            pageNum: page.pageNum,
            keyword: props.searchText,
            div: 2,
        })
            .then(({ data, code, msg }) => {
                if (code === 0) {
                    setLoading(false);
                    setProjectList(state => {
                        if (isFresh) {
                            return data.list || [];
                        }
                        return state.concat(data.list || []);
                    });
                    setTotalList(data?.page?.totalList || 0);
                } else {
                    setLoading(false);
                    throw msg;
                }
            })
            .catch(err => {
                setLoading(false);
                throw err;
            });
    };

    const updateFetch = () => {
        if (+page.page !== 1) {
            setLoadMoreLoading(true);
            setTimeout(() => {
                bodyScrollToBottom();
            });
            fetchData(setLoadMoreLoading, false, page.page);
        } else {
            setFreshLoading(true);
            fetchData(setFreshLoading, true, 1);
        }
    };

    useEffect(() => {
        setLoading(true);
        fetchData(setLoading, false, 1);
    }, []);

    useEffect(() => {
        if (projectList.length === +totalList && page.page !== 1) {
            setDone(true);
            setTimeout(() => {
                bodyScrollToBottom();
            });
        } else {
            setDone(false);
        }
    }, [totalList, projectList]);

    useDidUpdate(updateFetch, [page.page, props.searchText]);

    useEffect(() => {
        let hammer = new Hammer(touchEl.current, {
            threshold: 0,
            touchAction: 'pan-y',
        });
        hammer.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
        const handlePanstart = e => {
            let isScrollTop = document.documentElement.scrollTop === 0;
            let clientHeight = isScrollTop
                ? document.body.clientHeight
                : document.documentElement.clientHeight;
            let scrollTop = isScrollTop
                ? document.body.scrollTop
                : document.documentElement.scrollTop;
            let scrollHeight = isScrollTop
                ? document.body.scrollHeight
                : document.documentElement.scrollHeight;
            if (
                scrollTop !== 0 &&
                clientHeight + scrollTop === scrollHeight &&
                e.direction === 8
            ) {
                setPage(state => {
                    return { ...state, page: state.page + 1 };
                });
            } else if (scrollTop === 0 && e.direction === 16) {
                if (page.page === 1) {
                    fetchData(setFreshLoading, true, 1);
                    setPage({ page: 1 });
                } else {
                    setPage({ page: 1 });
                }
            }
        };
        hammer.on('panstart', handlePanstart);
        return () => {
            hammer.remove('panstart', handlePanstart);
        };
    }, []);

    const deleteOneReq = schemeId => {
        setLoading(true);
        return deleteScheme({ schemeId })
            .then(({ code, msg }) => {
                console.log('code', code);
                if (code === 0) {
                    message.success(msg);
                    // getData(page.page);
                    const index = projectList.findIndex(v => schemeId === v.id);
                    console.log(index);
                    projectList.splice(index, 1);
                    setProjectList(projectList);
                } else {
                    throw msg;
                }
            })
            .catch(({ msg }) => {
                throw msg;
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const deleteOne = schemeId => {
        Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: intl.get('userCenter.deleteDecoration'),
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            centered: true,
            async onOk(close) {
                try {
                    await deleteOneReq(schemeId);
                    close();
                } catch (e) {
                    close();
                }
            },
        });
    };
    const replayOne = schemeId => {
        setLoading(true);
        schemeReply({ schemeId })
            .then(({ code, msg }) => {
                if (code === 0) {
                    message.success(msg);
                    const index = projectList.findIndex(v => schemeId === v.id);
                    console.log(index);
                    projectList.splice(index, 1);
                    setProjectList(projectList);
                } else {
                    throw msg;
                }
            })
            .catch(({ msg }) => {
                throw msg;
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <Spin spinning={loading} wrapperClassName="scheme-tab-mobile">
            <div className="gap"></div>
            {isMobile() ? props.searchEl : null}
            <div className="my-scheme-tab" ref={touchEl}>
                <Spin spinning={freshLoading} size="small">
                    <div
                        className="fresh"
                        style={{ height: freshLoading ? '30px' : 0 }}></div>
                </Spin>
                {projectList.map((e, i) => (
                    <HouseTypeCard
                        key={i}
                        isComplete={false}
                        appendMeta={
                            <span style={{ color: 'rgba(0,0,0,0.4)' }}>
                                {intl.get('mySchemeTab.lastModified')}
                                {dayjs
                                    .unix(e.updateDate)
                                    .format('YYYY-MM-DD HH:mm')}
                            </span>
                        }
                        {...e}
                        titleClickHandler={() => targetDetail(e.id)}
                        render={() =>
                            props.type === 'discard' ? (
                                <Button onClick={() => replayOne(e.id)}>
                                    {intl.get('mySchemeTab.recovery')}
                                </Button>
                            ) : (
                                <DeleteOutlined
                                    onClick={() => deleteOne(e.id)}
                                    className="more-icon"
                                />
                            )
                        }
                    />
                ))}
                <Spin spinning={loadMoreLoading} size="small">
                    <div
                        className="load-more"
                        style={{
                            height: loadMoreLoading || done ? '50px' : '0',
                        }}>
                        {done ? intl.get('mySchemeTab.noMore') : ''}
                    </div>
                </Spin>
            </div>
        </Spin>
    );
}
